import React from 'react';
import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';

const style = {
    CardHeader: {
        fontSize: '18px !important'
    },
    width: '100%',
    height: 'calc(100vh - 155px)',
    overflowY: 'scroll',
    marginBottom: 10,
    borderBottom: 'solid 15px #fff',
    minHeight: 455
};

function CardFullHeight(props) {
    return(
        <Card style={style}>
            <CardText>
                {props.children}
            </CardText>
        </Card>
    )
}

export default CardFullHeight;



// WEBPACK FOOTER //
// ./src/views/components/cards/CardFullHeight.js